<template>
  <div class="bg-custom-lightgreen p-5 lg:p-40 mb-16">
    <!-- news letter title  -->
    <h1
      class="text-custom-darkblue text-center text-3xl md:text-6xl font-semibold capitalize mb-14"
    >
      subscribe NewsLetter
    </h1>
    <div class="grid justify-self-center justify-items-center ">
      <!-- input field for email -->
      <input
        class="w-80 md:w-96 h-14 p-5  border-custom-lightblue border border-opacity-20 mb-8"
        type="text"
        placeholder="Your Email Goes Here"
      />
      <!-- subscribe button  -->

      <button
        class="bg-custom-purple hover:bg-custom-lightblue w-72 md:w-96 h-14 uppercase font-semibold text-white"
      >
        sign me up
      </button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
};
</script>
<style></style>
